import axios from 'axios'
// const dispatchApiUrl = process.env === 'production' ? 'https://dispatch-api.taxibookingapps.com/' : 'http://core-api.test/';
// const apiUrl =  process.env === 'production' ? 'https://api-kellys.workupdate.net/' : 'http://kelly-api.test/';
//  const dispatchApiUrl =  'https://core-api.test/';
//   const apiUrl =   'https://kelly-api.test/';
const dispatchApiUrl = 'https://dispatch-api.taxibookingapps.com/';
const apiUrl =  'https://api.kellystaxi.com/';
export const getRequests = (url) => {
        return axios.get(apiUrl+url).then(res => res.data)
};

export const postRequest = (url,data) => {
        return axios.post(apiUrl+url, data).then(res => res.data)
};

export const postCoreRequest = (url,data) => {
        const apiKey = 'uEzYpw9RMVXgsAFL4OJK2Hu3Q5Ol7p2LlBpFEMSlbKERtITgC3ib9YNRkutz';
        const api_url = dispatchApiUrl  + url + (url.includes('?') ? '&' : '?') + 'key=' + apiKey;
        return axios.post(api_url, data).then(res => res.data)
};

export const getCoreRequests = (url) => {
        const apiKey = 'uEzYpw9RMVXgsAFL4OJK2Hu3Q5Ol7p2LlBpFEMSlbKERtITgC3ib9YNRkutz';
        const api_url = dispatchApiUrl  + url + (url.includes('?') ? '&' : '?') + 'key=' + apiKey;
        return axios.get(api_url).then(res => res.data)
};
